import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { baseURL, CreateNGO } from "../../../utils/EndPoint";
import Loading from "../../loadingPage/Loading";
import FileInput from "../FileInput";
import axios from "axios";
import ProjectDetail from "../ProjectDetail";
import FileInputImg from "../FileInputImg";
import { validateForm1Data } from "../../../utils/validation/formValidation";
import MultiFileInput from "../MultiFileInput";

const kmaPaymentDetails = {
  NonKmaAmount: 4130,
  NonKmaWithGSTAmount: 4130,
  KMAAmount: 2500,
  KMAWithGSTAmount: 2950,
};

const Form1 = () => {
  const [loader, setLoader] = useState(false);
  const [agreed, setAgreed] = useState(false);
  const [formErrors, setFormErrors] = useState({}); // State to store form errors

  const generateId = () => `${Date.now()}-${Math.random().toString(36)}`;

  const projectDetailInitial = {
    id: generateId(),
    name: "",
    keyTheme: "",
    scaledExamples: "",
    fundGenerations: "",
    sourceOfFunding: "",
    location: "",
    startDate: null,
    endDate: null,
    duration: {
      years: 0,
      months: 0,
      days: 0,
    },

    totalAmountSpent: {
      fy_2020_21: "",
      fy_2021_22: "",
      fy_2022_23: "",
      fy_2023_24: "",
      total: "",
    },
    needBaselineStudies: "",
    concernsAddressed: "",
    objectiveAlignment: "",
    stakeholders: "",
    totalBeneficiaries: 0,
    innovativeMethods: "",
    donorMonitor: "",
    impact: "",
    impactAssessment: {
      conducted: false,
      by: "",
      thirdPartyAgencyName: "",
      report: {
        name: "",
        key: "",
        size: "",
        location: "",
      },
    },
    sustainabilityStrategy: "",
    replicabilityProbability: "",
  };

  const initialData = {
    formName: "NGO",
    isKmaMember: false,
    membershipId: "",
organizationProfile: {
  name: "",
  description: "",
  yearOfEstablishment: "",
  legalStatus: "",
  governingBodyDetails: "",
  thematicAreas: "",
  activeGeographies: "",
  
  // ← Add these lines
  purpose_q1: "", purpose_q2: "", purpose_q3: "", purpose_q4: "",
  strategy_q5: "", strategy_q6: "", strategy_q7: "", strategy_q8: "", strategy_q9: "", strategy_q10: "",
  gov_q11: "", gov_q12: "", gov_q13: "", gov_q14: "",
  mon_q15: "", mon_q16: "", mon_q17: "",
  comp_q18: "", comp_q19: "",
},

    projectDetails: [projectDetailInitial],

    attachments: {
organizationProfile: [],

      csrPolicy: {
        name: "",
        key: "",
        size: "",
        location: "",
      },
      csrProjectReport: {
        name: "",
        key: "",
        size: "",
        location: "",
      },
      impactAssessmentReport: {
        name: "",
        key: "",
        size: "",
        location: "",
      },
    },

    paymentDetails: {
      mode: "",
      amount: kmaPaymentDetails?.NonKmaAmount,
      amountWithGst: kmaPaymentDetails?.NonKmaWithGSTAmount,
      transactionId: "",
      muid: "",
      receipt: {
        name: "",
        key: "",
        location: "",
      },
    },
  };

  const [formData, setFormData] = useState(initialData);

  // common input change handler
  const inPutChangeHandler = (e) => {
    const { name, value } = e.target;

    if (name === "isKmaMember") {
      // Update 'isKmaMember' state
      setFormData((prev) => ({
        ...prev,
        [name]: value === "true",
      }));

      // Set payment details based on KMA membership status
      if (value === "true") {
        setFormData((prev) => ({
          ...prev,
          paymentDetails: {
            ...prev.paymentDetails,
            amount: kmaPaymentDetails?.KMAAmount,
            amountWithGst: kmaPaymentDetails?.KMAWithGSTAmount,
          },
        }));
      } else {
        setFormData((prev) => ({
          ...prev,
          paymentDetails: {
            ...prev.paymentDetails,
            amount: kmaPaymentDetails?.NonKmaAmount,
            amountWithGst: kmaPaymentDetails?.NonKmaWithGSTAmount,
          },
        }));
      }
    } else {
      // Update other fields in formData
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const organizationInputHandler = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => {
      const updatedFormData = {
        ...prev,
        organizationProfile: {
          ...prev.organizationProfile,
          [name]: value,
        },
      };

      // Validate the specific field only
      const errors = validateForm1Data(updatedFormData);
      // if (errors[name]) {
      //   toast.error(errors[name]); // Show error toast
      // }
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        [name]: errors[name] || "", // Update only the current field's error
      }));

      return updatedFormData;
    });
  };

  // Payment mode Update
  const paymentChangeHandler = (e) => {
    const modeValue = e.target.value;

    setFormData((prev) => {
      const updatedFormData = {
        ...prev,
        paymentDetails: {
          ...prev.paymentDetails,
          mode: modeValue, // Update the mode field
        },
      };

      // Validate the specific field only
      const errors = validateForm1Data(updatedFormData);
      if (errors.mode) {
        toast.error(errors.mode); // Show error toast for the mode field
      }
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        mode: errors.mode || "", // Update only the mode field's error
      }));

      return updatedFormData;
    });
  };

  const backToBasics = () => {
    window.scrollTo(0, 0);
    setFormData(initialData);
    setAgreed(false);
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    console.log(formData);
    const errors = validateForm1Data(formData);
    console.log(errors);

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);

      // Show each error in a separate toast
      Object.values(errors).forEach((errorMsg) => {
        toast.error(errorMsg); // Display each error
      });

      return;
    }

    // Validate organization profile attachments
    // const requiredAttachments = [
      // {
      //   field: "organizationProfile",
      //   label: "Profile of the Organization (PDF/Doc)",
      // },
      // { field: "csrPolicy", label: "CSR Policy (PDF/Doc)" },
      // { field: "csrProjectReport", label: "CSR Project Report" },
    // ];
   

    console.log("Attachment:", formData.attachments.organizationProfile);
    try {
      setLoader(true);
      const response = await axios.post(
        `${baseURL}${CreateNGO}`,
        formData
      );

      // console.log(response)
      if (response?.data?.redirectUrl) {
        window.location.href = response?.data?.redirectUrl;
        toast.warning(
          "Please Wait for the Payment Gateway DON'T CLOSE ANYTHING"
        );
        window.scrollTo(0, 0);
        setFormData(initialData);
      } else {
        toast.success("Your Application Successfully Submitted");
        window.scrollTo(0, 0);
        console.log("Reset attachments to:", initialData.attachments.organizationProfile);
        setFormData(initialData);
      }
      
    } catch (error) {
      console.log(error.response?.data);
      toast.error(error?.response?.data?.msg || "Try again after sometime");
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    // window.scrollTo(0, 0);
  }, []);

  const addProjectDetail = () => {
    if (formData?.projectDetails?.length > 4) {
      return;
    }

    setFormData((prev) => ({
      ...prev,
      projectDetails: [
        ...prev.projectDetails,
        {
          ...projectDetailInitial,
          id: generateId(),
        },
      ],
    }));
  };

  const removeProjectDetail = (id) => {
    if (formData?.projectDetails?.length < 2) {
      return;
    }

    const newData = formData?.projectDetails?.filter((item) => item?.id !== id);

    setFormData((prev) => ({
      ...prev,
      projectDetails: newData,
    }));
  };

  // console.log({ formData })
  return (
    <>
      <h1 className="font-bold font-sherif text-textColor text-2xl text-center mb-5 lg:mb-10">
        Impactful NGO Awards 2026
      </h1>
      <div className="flex items-start justify-center border rounded-xl shadow-xl w-full max-w-[1280px] mx-auto">
        <form
          className="w-full flex flex-col items-center justify-center md:px-20 p-5 md:p-10"
          action=""
          onSubmit={submitHandler}
        >
          {/* Division heading */}
          <div className="text-start w-full font-semibold mb-2">
            <h2>Organization Profile</h2>
          </div>
          {/* Organization /adress */}
          <div className="w-full md:mt-3  flex flex-col md:flex-row gap-2 py-1">
            <div className="w-full space-y-2">
              <label
                htmlFor=""
                className="text-[#777777] text-[12px] md:text-[13px] font-medium"
              >
                Name of the Applicant Organization * :
              </label>
              <input
                type="text"
                name="name"
                required
                value={formData?.organizationProfile?.name}
                onChange={organizationInputHandler}
                placeholder="Eg: Qmark Technolabs"
                className={`border w-full md:full p-2 md:p-3 text-gray-700 text-[10px] md:text-xs rounded ps-2 outline-none ${
                  formErrors.name ? "border-red-500" : "border-[#771D32]/40"
                }`}
              />
              {formErrors.name && (
                <p className="text-red-500 text-sm mt-1">{formErrors.name}</p>
              )}
            </div>
            <div className="w-full space-y-2">
              <label
                htmlFor=""
                className="text-[#777777] text-[12px] md:text-[13px] font-medium"
              >
                Year of Establishment* :
              </label>
              <input
                type="number"
                name="yearOfEstablishment"
                value={formData?.organizationProfile?.yearOfEstablishment}
                placeholder=""
                onChange={organizationInputHandler}
                className={`border w-full md:full p-2 md:p-3 text-gray-700 text-[10px] md:text-xs rounded ps-2 outline-none ${
                  formErrors.yearOfEstablishment
                    ? "border-red-500"
                    : "border-[#771D32]/40"
                }`}
              />
              {formErrors.yearOfEstablishment && (
                <p className="text-red-500 text-sm mt-1">
                  {formErrors.yearOfEstablishment}
                </p>
              )}
            </div>
          </div>

          {/* contact & Email*/}
          <div className="w-full  flex flex-col md:flex-row gap-2 py-1">
            <div className="w-full space-y-2">
              <label
                htmlFor=""
                className="text-[#777777] text-[12px] md:text-[13px] font-medium"
              >
                Legal Status of the Organization * :
              </label>
              <input
                type="text"
                name="legalStatus"
                value={formData?.organizationProfile?.legalStatus}
                onChange={organizationInputHandler}
                placeholder="Eg: Society, Trust, Section 8 Company"
                className={`border w-full md:full p-2 md:p-3 text-gray-700 text-[10px] md:text-xs rounded ps-2 outline-none ${
                  formErrors.legalStatus
                    ? "border-red-500"
                    : "border-[#771D32]/40"
                }`}
              />
              {formErrors.legalStatus && (
                <p className="text-red-500 text-sm mt-1">
                  {formErrors.legalStatus}
                </p>
              )}
            </div>
            <div className="w-full space-y-2">
              <label
                htmlFor=""
                className="text-[#777777] text-[12px] md:text-[13px] font-medium"
              >
                Governing Body Details* :
              </label>
              <input
                type="text"
                name="governingBodyDetails"
                placeholder=""
                value={formData?.organizationProfile?.governingBodyDetails}
                onChange={organizationInputHandler}
                className={`border w-full md:full p-2 md:p-3 text-gray-700 text-[10px] md:text-xs rounded ps-2 outline-none ${
                  formErrors.governingBodyDetails
                    ? "border-red-500"
                    : "border-[#771D32]/40"
                }`}
              />
              {formErrors.governingBodyDetails && (
                <p className="text-red-500 text-sm mt-1">
                  {formErrors.governingBodyDetails}
                </p>
              )}
            </div>
          </div>

          {/*Governing Body Details*/}
          <div className="w-full  flex flex-col md:flex-row gap-2 py-1">
            <div className="w-full space-y-2">
              <label
                htmlFor=""
                className="text-[#777777] text-[12px] md:text-[13px] font-medium"
              >
                Thematic Areas of Intervention :
              </label>
              <input
                type="text"
                name="thematicAreas"
                value={formData?.organizationProfile?.thematicAreas}
                onChange={organizationInputHandler}
                placeholder="Eg: Education, Health, Skills Development, Women Empowerment"
                className={`border w-full md:full p-2 md:p-3 text-gray-700 text-[10px] md:text-xs rounded ps-2 outline-none ${
                  formErrors.thematicAreas
                    ? "border-red-500"
                    : "border-[#771D32]/40"
                }`}
              />
              {formErrors.thematicAreas && (
                <p className="text-red-500 text-sm mt-1">
                  {formErrors.thematicAreas}
                </p>
              )}
            </div>
            <div className="w-full space-y-2">
              <label
                htmlFor=""
                className="text-[#777777] text-[12px] md:text-[13px] font-medium"
              >
                Active Geographies* :
              </label>
              <input
                type="text"
                name="activeGeographies"
                value={formData?.organizationProfile?.activeGeographies}
                onChange={organizationInputHandler}
                placeholder="States and Districts"
                className={`border w-full md:full p-2 md:p-3 text-gray-700 text-[10px] md:text-xs rounded ps-2 outline-none ${
                  formErrors.activeGeographies
                    ? "border-red-500"
                    : "border-[#771D32]/40"
                }`}
              />
              {formErrors.activeGeographies && (
                <p className="text-red-500 text-sm mt-1">
                  {formErrors.activeGeographies}
                </p>
              )}
            </div>
          </div>

          {/* Brief Description of the Organization */}
          <div className="w-full flex flex-col md:flex-row gap-2 py-1">
            <div className="w-full space-y-2">
              <label
                htmlFor=""
                className="text-[#777777] text-[12px] md:text-[13px] font-medium"
              >
                Brief Description of the Applicant Organization (in about 50
                words):
              </label>
              <textarea
                value={formData?.organizationProfile?.description}
                name="description"
                id=""
                onChange={organizationInputHandler}
                className={`border w-full md:w-full p-2 md:p-3 text-gray-700 text-[10px] md:text-xs rounded ps-2 outline-none ${
                  formErrors.description
                    ? "border-red-500"
                    : "border-[#771D32]/40"
                }`}
              />
              {formErrors.description && (
                <p className="text-red-500 text-sm mt-1">
                  {formErrors.description}
                </p>
              )}
            </div>
          </div>

          {/* Division heading */}
          {/* <div className="text-start w-full font-semibold my-5">
            <h2>
              Project Details{" "}
              <span className="text-xs "> (Add upto 5 Projects)</span>
            </h2>
          </div>

          {formData?.projectDetails?.map((item, index) => (
            <ProjectDetail
              key={item?.id}
              index={index}
              item={item}
              removeProjectDetail={removeProjectDetail}
              formData={formData}
              setFormData={setFormData}
            />
          ))}

          <button
            type="button"
            onClick={addProjectDetail}
            className="bg-blue-600 text-white text-sm p-2 rounded-md my-4 "
          >
            Add Project
          </button> */}



{/* ================= NGO EVALUATION QUESTIONNAIRE ================= */}
          
          {/* 1. PURPOSE */}
          <div className="text-start w-full font-semibold my-5 border-t pt-5">
            <h2 className="text-black text-lg font-bold">Purpose</h2>
          </div>
          <div className="w-full space-y-4">
            {[
              { l: "1. What is the core purpose and mission of the NGO?", n: "purpose_q1" },
              { l: "2. What are the key focus areas and thematic priorities of the organisation?", n: "purpose_q2" },
              { l: "3. What is the geographical scope of the NGO's operations?", n: "purpose_q3" },
              { l: "4. How does the organisation's work align with the UN Sustainable Development Goals (SDGs)? Please specify the relevant SDGs and targets.", n: "purpose_q4" }
            ].map((q) => (
              <div key={q.n} className="w-full space-y-2">
                <label className="text-[#777777] text-[12px] md:text-[13px] font-medium">{q.l}</label>
                <textarea
                  name={q.n}
                  value={formData?.organizationProfile?.[q.n]}
                  onChange={organizationInputHandler}
                  rows={3}
className={`border w-full p-2 md:p-3 text-gray-700 text-xs rounded outline-none ${
    formErrors[q.n] ? "border-red-500" : "border-[#771D32]/40"
  }`}                />
  {formErrors[q.n] && (
  <p className="text-red-500 text-sm mt-1">
    {formErrors[q.n]}
  </p>
)}
              </div>
            ))}
          </div>

          {/* 2. STRATEGY */}
          <div className="text-start w-full font-semibold my-5 border-t pt-5">
            <h2 className="text-black text-lg font-bold">Strategy</h2>
          </div>
          <div className="w-full space-y-4">
            {[
              { l: "5. Please describe the NGO's operating model for programme design and implementation.", n: "strategy_q5" },
              { l: "6. What is the size of the organisation, in terms of staff strength, volunteers, and scale of operations?", n: "strategy_q6" },
              { l: "7. What are the NGO's primary funding sources, and how diversified are they?", n: "strategy_q7" },
              { l: "8. Who are the key personnel and leadership team, and what relevant expertise do they bring?", n: "strategy_q8" },
              { l: "9. How is programme management structured to ensure effective delivery and accountability?", n: "strategy_q9" },
              { l: "10. What impact framework does the NGO use to design, manage, and assess its interventions (e.g., Theory of Change or similar)?", n: "strategy_q10" }
            ].map((q) => (
              <div key={q.n} className="w-full space-y-2">
                <label className="text-[#777777] text-[12px] md:text-[13px] font-medium">{q.l}</label>
                <textarea
                  name={q.n}
                  value={formData?.organizationProfile?.[q.n]}
                  onChange={organizationInputHandler}
                  rows={3}
 className={`border w-full p-2 md:p-3 text-gray-700 text-xs rounded outline-none ${
    formErrors[q.n] ? "border-red-500" : "border-[#771D32]/40"
  }`}
/>

{formErrors[q.n] && (
  <p className="text-red-500 text-sm mt-1">
    {formErrors[q.n]}
  </p>
)}              </div>
            ))}
          </div>

          {/* 3. GOVERNANCE */}
          <div className="text-start w-full font-semibold my-5 border-t pt-5">
            <h2 className="text-black text-lg font-bold">Governance</h2>
          </div>
          <div className="w-full space-y-4">
            {[
              { l: "11. What is the governance structure of the NGO, including Board composition and oversight mechanisms?", n: "gov_q11" },
              { l: "12. Who are the organisation's key stakeholders, and how are they engaged in decision-making and programme implementation?", n: "gov_q12" },
              { l: "13. What policies, codes, and internal controls are formally adopted and publicly disclosed?", n: "gov_q13" },
              { l: "14. What public disclosures and transparency practices does the NGO follow (e.g., annual reports, audited financials)?", n: "gov_q14" }
            ].map((q) => (
              <div key={q.n} className="w-full space-y-2">
                <label className="text-[#777777] text-[12px] md:text-[13px] font-medium">{q.l}</label>
                <textarea
                  name={q.n}
                  value={formData?.organizationProfile?.[q.n]}
                  onChange={organizationInputHandler}
                  rows={3}
 className={`border w-full p-2 md:p-3 text-gray-700 text-xs rounded outline-none ${
    formErrors[q.n] ? "border-red-500" : "border-[#771D32]/40"
  }`}
/>

{formErrors[q.n] && (
  <p className="text-red-500 text-sm mt-1">
    {formErrors[q.n]}
  </p>
)}              </div>
            ))}
          </div>

          {/* 4. MONITORING */}
          <div className="text-start w-full font-semibold my-5 border-t pt-5">
            <h2 className="text-black text-lg font-bold">Monitoring</h2>
          </div>
          <div className="w-full space-y-4">
            {[
              { l: "15. What theory of change or equal impact indicators and performance metrics are used to measure outcomes?", n: "mon_q15" },
              { l: "16. What has been the NGO's performance against these indicators during the current reporting year?", n: "mon_q16" },
              { l: "17. Has the NGO received any recognitions, awards, or certifications relevant to sustainability?", n: "mon_q17" }
            ].map((q) => (
              <div key={q.n} className="w-full space-y-2">
                <label className="text-[#777777] text-[12px] md:text-[13px] font-medium">{q.l}</label>
                <textarea
                  name={q.n}
                  value={formData?.organizationProfile?.[q.n]}
                  onChange={organizationInputHandler}
                  rows={3}
 className={`border w-full p-2 md:p-3 text-gray-700 text-xs rounded outline-none ${
    formErrors[q.n] ? "border-red-500" : "border-[#771D32]/40"
  }`}
/>

{formErrors[q.n] && (
  <p className="text-red-500 text-sm mt-1">
    {formErrors[q.n]}
  </p>
)}              </div>
            ))}
          </div>

          {/* 5. COMPLIANCE */}
          <div className="text-start w-full font-semibold my-5 border-t pt-5">
            <h2 className="text-black text-lg font-bold">Compliance</h2>
          </div>
          <div className="w-full space-y-4">
            {[
              { l: "18. Under what legal and regulatory framework does the NGO operate?", n: "comp_q18" },
              { l: "19. Have there been any controversies, regulatory actions, or legal proceedings associated with the organisation?", n: "comp_q19" }
            ].map((q) => (
              <div key={q.n} className="w-full space-y-2">
                <label className="text-[#777777] text-[12px] md:text-[13px] font-medium">{q.l}</label>
                <textarea
                  name={q.n}
                  value={formData?.organizationProfile?.[q.n]}
                  onChange={organizationInputHandler}
                  rows={3}
 className={`border w-full p-2 md:p-3 text-gray-700 text-xs rounded outline-none ${
    formErrors[q.n] ? "border-red-500" : "border-[#771D32]/40"
  }`}
/>

{formErrors[q.n] && (
  <p className="text-red-500 text-sm mt-1">
    {formErrors[q.n]}
  </p>
)}              </div>
            ))}
          </div>


          {/* Division heading */}
          <div className="text-start w-full font-semibold my-5">
            <h2>Financial and Payment Details</h2>
          </div>

          {/*payment option */}
          <div className="w-full flex flex-col md:flex-row gap-2 py-1">
            <div className="w-full space-y-2">
              <label
                htmlFor=""
                className="text-[#777777] text-[12px] md:text-[13px] font-medium"
              >
                is KMA Member?*
              </label>
              <select
                id=""
                name="isKmaMember"
                value={formData?.isKmaMember}
                onChange={inPutChangeHandler}
                className="border border-[#771D32]/40 w-full md:full p-2 md:p-3 text-gray-700 text-[10px] md:text-xs rounded  placeholder:text-xs ps-2 outline-none
                   focus:outline-none focus:shadow-outline font-medium"
              >
                <option
                  value=""
                  className="text-xs ring-0 outline-none focus:outline-none"
                >
                  Select a category
                </option>
                <option
                  value={true}
                  className="text-xs ring-0 outline-none focus:outline-none"
                >
                  KMA Member
                </option>
                <option
                  value={false}
                  className="text-xs ring-0 outline-none focus:outline-none"
                >
                  Non-KMA Member
                </option>
              </select>
            </div>
            <div
              className={`w-full space-y-2 ${
                formData?.isKmaMember ? "block" : "hidden"
              }`}
            >
              <label
                htmlFor=""
                className="text-[#777777] text-[12px] md:text-[13px] font-medium"
              >
                Membership Id*
              </label>
              <input
                type="text"
                name="membershipId"
                onChange={inPutChangeHandler}
                placeholder=""
                className="border border-[#771D32]/40 w-full md:full p-2 md:p-3 text-gray-700 text-[10px] md:text-xs rounded  placeholder:text-xs ps-2 outline-none"
              />
              {formData.isKmaMember && formErrors.membershipId && (
  <p className="text-red-500 text-sm mt-1">{formErrors.membershipId}</p>
)}
            </div>
          </div>
          <div className="w-full flex flex-col md:flex-row gap-2 py-1">
            <div className="w-full space-y-2">
              <label
                htmlFor=""
                className="text-[#777777] text-[12px] md:text-[13px] font-medium"
              >
                Application Amount (with GST) :
              </label>
              <input
                type="text"
                name="amountWithGst"
                //
                readOnly
                value={formData?.paymentDetails?.amountWithGst}
                placeholder=""
                className="border border-[#771D32]/40 w-full md:full p-2 md:p-3 text-gray-700 text-[10px] md:text-xs rounded  placeholder:text-xs ps-2 outline-none"
              />
            </div>

            <div className="w-full space-y-2">
              <label
                htmlFor=""
                className="text-[#777777] text-[12px] md:text-[13px] font-medium"
              >
                Payment Details :*
              </label>
              <select
                id=""
                name="mode"
                value={formData?.paymentDetails?.mode}
                onChange={paymentChangeHandler}
                className={`border w-full md:full p-2 md:p-3 text-gray-700 text-[10px] md:text-xs rounded ps-2 outline-none focus:outline-none focus:shadow-outline font-medium ${
                  formErrors.mode ? "border-red-500" : "border-[#771D32]/40"
                }`}
              >
                <option
                  name=""
                  className="text-xs ring-0 outline-none focus:outline-none"
                >
                  Select a category
                </option>
                <option
                  name=""
                  className="text-xs ring-0 outline-none focus:outline-none"
                >
                  Cheque
                </option>
                <option
                  name=""
                  className="text-xs ring-0 outline-none focus:outline-none"
                >
                  DD No.
                </option>
                <option
                  name=""
                  className="text-xs ring-0 outline-none focus:outline-none"
                >
                  Online
                </option>
              </select>
              {formErrors.mode && (
                <p className="text-red-500 text-sm mt-1">{formErrors.mode}</p>
              )}
            </div>

<FileInputImg
  className={`w-full space-y-2 ${formData?.paymentDetails?.mode === "Online" ? "hidden" : "block"}`}
  label="Payment Receipt (png or jpg)"
  name="receipt"
  allowedFileTypes={["image/jpeg", "image/jpg", "image/png"]}
  setFile={(file) => {
    setFormData((prev) => {
      const updatedFormData = {
        ...prev,
        paymentDetails: {
          ...prev.paymentDetails,
          receipt: file,
        },
      };

      // Immediately validate after setting the file
      const errors = validateForm1Data(updatedFormData);

      // Clear receipt error if file is now present
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        receipt: errors.receipt || "",   // will be "" if valid
      }));

      return updatedFormData;
    });
  }}
/>

{formData.paymentDetails.mode !== "Online" && formErrors.receipt && (
  <p className="text-red-500 text-sm mt-1">{formErrors.receipt}</p>
)}
          </div>

          <div className="my-6 w-full">
            <span className="font-bold">Note : </span>
            <span className="font-">
              Please ensure all file fields are completed before submitting the
              form. Additionally, kindly ensure that each file is under 25MB in
              size.
            </span>
          </div>

          {/* Division heading */}
          <div className="text-start w-full font-semibold my-5">
            <h2> Required Attachments</h2>
          </div>

          {/*Document */}
          <div className="w-full space-y-2">
<MultiFileInput
  label="Supported Documents (PDF/Doc)"
  name="organizationProfile"
  setFiles={(newFiles) => {
    setFormData((prev) => {
      const existingFiles = Array.isArray(prev.attachments?.organizationProfile)
        ? prev.attachments.organizationProfile
        : [];

      const updatedFiles = [...existingFiles, ...newFiles];

      const updatedFormData = {
        ...prev,
        attachments: {
          ...prev.attachments,
          organizationProfile: updatedFiles,
        },
      };

      // Clear the error if there is now at least one file
      if (updatedFiles.length > 0) {
        setFormErrors((prevErrors) => ({
          ...prevErrors,
          organizationProfile: "",   // ← removes red message instantly
        }));
      }

      return updatedFormData;
    });
  }}
/>



{Array.isArray(formData?.attachments?.organizationProfile) &&
  formData.attachments.organizationProfile.length > 0 && (
    <div className="mt-3 space-y-2">
      {formData.attachments.organizationProfile.map((file, index) => (
        <div
          key={index}
          className="flex items-center justify-between bg-gray-100 px-3 py-2 rounded text-sm"
        >
          <span className="truncate">{file.name}</span>

          <button
            type="button"
            onClick={() => {
              setFormData((prev) => ({
                ...prev,
                attachments: {
                  ...prev.attachments,
                  organizationProfile:
                    prev.attachments.organizationProfile.filter(
                      (_, i) => i !== index
                    ),
                },
              }));
            }}
            className="text-red-500 text-xs hover:underline"
          >
            Remove
          </button>
        </div>
      ))}
    </div>
)}
  {formErrors.organizationProfile && (
    <p className="text-red-500 text-sm">
      {formErrors.organizationProfile}
    </p>
  )}
            {/* <FileInput
              className={`w-full space-y-2`}
              label="CSR Policy/Practices (PDF/Doc)"
              name="csrPolicy"
              setFile={(file) =>
                setFormData((prev) => ({
                  ...prev,
                  attachments: {
                    ...prev.attachments,
                    csrPolicy: file,
                  },
                }))
              }
            /> */}
          </div>

          {/* <div className="w-full flex flex-col md:flex-row gap-2 py-1">
            <FileInput
              className={`w-full space-y-2`}
              label="CSR Project Report/Case Study (PDF/Doc):"
              name="csrProjectReport"
              setFile={(file) =>
                setFormData((prev) => ({
                  ...prev,
                  attachments: {
                    ...prev.attachments,
                    csrProjectReport: file,
                  },
                }))
              }
            />
            <FileInput
              className={`w-full space-y-2`}
              label="Impact Assessment Report (if applicable):"
              name="impactAssessmentReport"
              setFile={(file) =>
                setFormData((prev) => ({
                  ...prev,
                  attachments: {
                    ...prev.attachments,
                    impactAssessmentReport: file,
                  },
                }))
              }
            />
          </div> */}

          <div className="w-full flex flex-col md:flex-row gap-2 py-1 mt-5">
            <span className="text-xs md:text-sm ">
              <input
                type="checkbox"
                checked={agreed}
                onChange={(e) => setAgreed(e.target.checked)}
                className="me-2"
              />
              I agree, on behalf of my organization, to abide by the rules of
              the KMA – Advocacy Awards 2026 and accept that the decisions of
              KMA are final and binding. I confirm all information in this
              application and accompanying documents are correct. I accept the
              timelines and the fee mentioned.
            </span>
          </div>

          {/* Submit Button */}
          <div className="w-full flex justify-center mt-10">
            <button
              disabled={!agreed}
              className="flex items-center justify-end border p-2 px-5 rounded bg-red-500 text-white"
            >
              {formData?.paymentDetails?.mode === "Online"
                ? " Pay Now & Submit"
                : "Submit"}
            </button>
          </div>
        </form>
        {loader && <Loading />}
      </div>
    </>
  );
};

export default Form1;
